import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { TimecardEntry, TimecardProject, DaySegment, daySegments, dayBackgroundSegments, dayTicks, duration, projectColor } from './timecard';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimecardDayTimeline',
  props: {
    entries: null,
    projects: null,
    start: null,
    end: null,
    now: null,
    timeZone: null,
    label: null,
    compact: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  entries: TimecardEntry[];
  projects: TimecardProject[];
  start: string;
  end: string;
  now: number;
  timeZone: string;
  label: string;
  compact?: boolean;
}


const start = computed(() => Date.parse(props.start));
const end = computed(() => Date.parse(props.end));
const isToday = computed(() => props.now >= start.value && props.now < end.value);
const sections = computed(() => {
  const work = daySegments(props.entries, props.now, start.value, end.value);
  return work.concat(dayBackgroundSegments(work, props.now, start.value, end.value)).sort((a, b) => a.start - b.start);
});
const ticks = computed(() => end.value > start.value ? dayTicks(start.value, end.value, props.timeZone) : []);
const nowPosition = computed(() => Math.max(0, Math.min(100, (props.now - start.value) / (end.value - start.value) * 100)));
const timeFormatter = computed(() => new Intl.DateTimeFormat('en-US', { timeZone: props.timeZone, hour: 'numeric', minute: '2-digit' }));
const shortTime = (instant: number) => timeFormatter.value.format(instant);
const color = (id: string | null) => projectColor(id, props.projects[0]?.id, props.projects[1]?.id);
const segmentLabel = (segment: DaySegment) => {
  let label = 'Not tracking';
  if (segment.projectId) label = props.projects.find(project => project.id === segment.projectId)?.name || 'Project';
  else if (segment.kind === 'remaining') label = isToday.value ? 'Remaining today' : 'Upcoming';
  return `${label}: ${shortTime(segment.start)} – ${shortTime(segment.end)} · ${duration((segment.end - segment.start) / 1000)}`;
};

return { __sfc: true,props, start, end, isToday, sections, ticks, nowPosition, timeFormatter, shortTime, color, segmentLabel }
}

})